function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useRef, useEffect } from 'react';
import { debounce } from '../../../../utilities/debounce.js';
var DEBOUNCE_PERIOD = 250;

function useIsSticky(mode, disabled, isFlushWhenSticky) {
  var hasIOSupport = typeof window !== 'undefined' && Boolean(window.IntersectionObserver);
  var options = {
    root: null,
    rootMargin: "".concat(isFlushWhenSticky ? '0px' : '-56px', " 0px 0px 0px"),
    threshold: 0
  };

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      indexFilteringHeight = _useState2[0],
      setIndexFiltersHeight = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSticky = _useState4[0],
      setIsSticky = _useState4[1];

  var measurerRef = useRef(null);
  var intersectionRef = useRef(null);

  var handleIntersect = function handleIntersect(entries) {
    entries.forEach(function (entry) {
      setIsSticky(!entry.isIntersecting);
    });
  };

  var observerRef = useRef(hasIOSupport ? new IntersectionObserver(handleIntersect, options) : null);
  useEffect(function () {
    function computeDimensions() {
      var node = measurerRef.current;

      if (!node) {
        return {
          height: 0
        };
      }

      var box = node.getBoundingClientRect();
      var height = box.height;
      setIndexFiltersHeight(height);
    }

    computeDimensions();
    var debouncedComputeDimensions = debounce(computeDimensions, DEBOUNCE_PERIOD, {
      trailing: true
    });
    window.addEventListener('resize', debouncedComputeDimensions);
    return function () {
      return window.removeEventListener('resize', debouncedComputeDimensions);
    };
  }, [measurerRef, mode]);
  useEffect(function () {
    var observer = observerRef.current;

    if (!observer) {
      return;
    }

    var node = intersectionRef.current;

    if (node) {
      observer.observe(node);
    }

    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  }, [intersectionRef]);
  return {
    intersectionRef: intersectionRef,
    measurerRef: measurerRef,
    isSticky: isSticky && !disabled,
    indexFilteringHeight: indexFilteringHeight
  };
}

export { useIsSticky };